import { Link } from "react-router-dom";
import Button from "../../../../components/Button";
import IconButton from "../../../../components/IconButton";
import Input from "../../../../components/Input";
import { IconKey, IconLeftArrowVersion2 } from "../../../../icons";

export const LostPassword = ({ handleRecoverPassword, email, setEmail, error, setError }) => {
  return (
    <>
      <div className="flex flex-col items-center w-3/5 sm:w-4/5">
        <IconButton icon={IconKey} className="icon-recoverPassword" />
        <div className="box-icon-key flex justify-center items-center"></div>
        <div className="box-pulse flex justify-center items-center"></div>
        <h1 className="text-5xl font-semibold">Esqueceu a senha?</h1>
        <p className="text-1.6rem mt-5 text-textPrimary text-center">
          Não se preocupe, nós vamos te ajudar. Digite seu e-mail no campo abaixo para definir uma nova senha
        </p>
      </div>
      <div
        className="flex flex-col items-center w-3/5 sm:w-4/5
 gap-4"
      >
        <Input
          name={"email"}
          label={"Email"}
          placeholder={"Digite seu e-mail aqui"}
          type="email"
          value={email}
          onChange={(e) => {
            if (e.target.value !== email) setError({ status: false, message: "" });
            setEmail(e.target.value);
          }}
          onKeyPress={(e) => e.key === "Enter" && handleRecoverPassword()}
          errorMessage={error.message}
          errorStatus={error.status}
          autoFocus
        />
      </div>
      <div
        className="flex flex-col w-3/5 sm:w-4/5
 gap-6 px-4"
      >
        <Button type="button" onClick={handleRecoverPassword} className="bg-primary w-full rounded-xl">
          Recupere sua senha
        </Button>

        <Link to="/login" className="w-full h-full">
          <Button className="w-full text-textPrimary hover:bg-gray-100 rounded-xl">
            <IconButton className="icon-back-login" icon={IconLeftArrowVersion2} /> Voltar para login
          </Button>
        </Link>
      </div>
    </>
  );
};
